import { Route } from "react-router-dom";
import { ClientList, CreateClient, UpdateClient } from "../Clients/Client";

export const CLIENT_ROUTES = [
    <Route key="clients-list" path="/clients/list" element={<ClientList />} />,
    <Route key="clients-create" path="/clients/create_client" element={<CreateClient />} />,
    <Route key="clients-update" path="/clients/update_client/:id" element={<UpdateClient />} />
];